export const ROUTE_HOLIDAY_SALE = '/holiday-sale';
export const ROUTE_HOLIDAY_SALE_BUY = `${ROUTE_HOLIDAY_SALE}/buy`;
export const ROUTE_HOLIDAY_SALE_CONFIRMED = `${ROUTE_HOLIDAY_SALE}/confirmed`;

export const ROUTE_HOLIDAY_SALE_AUTH = `${ROUTE_HOLIDAY_SALE}/auth`;
export const ROUTE_HOLIDAY_SALE_LOGIN = `${ROUTE_HOLIDAY_SALE_AUTH}/login`;
export const ROUTE_MY_BOOKS = '/my-books/book-catalog';
